import { TextareaHTMLAttributes, ReactNode, forwardRef } from 'react';

export interface TextareaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
    label?: ReactNode;
    error?: boolean;
    helperText?: ReactNode;
}

/**
 * Zone de texte multiligne — remplace MUI TextField multiline.
 */
const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(
    ({ label, error, helperText, className = '', ...rest }, ref) => (
        <div className="w-full">
            {label && (
                <label className="block text-xs font-semibold text-[var(--eb-text-muted)] mb-1.5">
                    {label}
                </label>
            )}
            <textarea
                ref={ref}
                className={`w-full px-3 py-2 text-sm rounded-lg border bg-[var(--eb-surface)] text-[var(--eb-text)]
                    placeholder:text-[var(--eb-text-muted)]/60 resize-y
                    focus:outline-none focus:ring-2 focus:ring-[var(--eb-primary)]/40 focus:border-[var(--eb-primary)]
                    transition-colors duration-150
                    disabled:opacity-50 disabled:cursor-not-allowed
                    ${error ? 'border-red-500 focus:ring-red-500/40 focus:border-red-500' : 'border-[var(--eb-border)]'}
                    ${className}`}
                {...rest}
            />
            {helperText && (
                <p className={`mt-1 text-xs ${error ? 'text-red-500' : 'text-[var(--eb-text-muted)]'}`}>
                    {helperText}
                </p>
            )}
        </div>
    )
);

Textarea.displayName = 'Textarea';
export default Textarea;
